import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../kotlin-react/react/create.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function create_0(_this__u8e3s4, rComponent, title, config, key) {
  key = key === VOID ? null : key;
  return create(_this__u8e3s4, ($this$create) => {
    $this$create.rComponent = rComponent;
    $this$create.title = title;
    $this$create.config = config;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  });
}
//region block: exports
export {
  create_0 as create3bks50kr3glko,
};
//endregion

//# sourceMappingURL=CouplingRoutePropsExtentions.mjs.map
